function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import IntroSectionComponent from './modules/IntroSectionComponent';
import SectionComponent from './modules/SectionComponent';
import SliderSectionComponent from './modules/SliderSectionComponent';
var BrainHearingComponent = function BrainHearingComponent(_ref) {
  var settings = _ref.settings,
    component = _ref.component,
    setFooterData = _ref.setFooterData,
    footerData = _ref.footerData;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    introSection = _useState2[0],
    setIntroSection = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    sectionData = _useState4[0],
    setSectionData = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    sliderSection = _useState6[0],
    setSliderSection = _useState6[1];
  var prepareFooterData = function prepareFooterData(introData) {
    var footerArr = [];
    var watchTheFilm, discoverMore, closeLink;
    introData.postElementItems.map(function (postElement) {
      if (postElement.type === 'link') {
        if (postElement.html.html.indexOf('has-video') > -1) {
          watchTheFilm = postElement.link.content;
        } else if (postElement.html.html.indexOf('close') > -1) {
          closeLink = postElement.link.content;
        } else {
          discoverMore = postElement.link.content;
        }
      }
    });
    introData.elements.map(function (element) {
      var image;
      var link;
      var title;
      element.items.map(function (item) {
        if (item.type === 'image') {
          image = item.image.src;
        }
        if (item.type === 'text') {
          var $html = new DOMParser().parseFromString(item.html.html, 'text/html');
          link = $html.querySelector('a').getAttribute('href');
          title = $html.querySelector('.section-title').innerText;
        }
      });
      footerArr.push({
        image: image,
        link: link,
        title: title,
        watchTheFilm: watchTheFilm || 'Watch the film',
        discoverMore: discoverMore || 'Discover more',
        closeLink: closeLink || 'CLOSE'
      });
    });
    setFooterData(footerArr);
  };
  useEffect(function () {
    if (component.classList.contains('brain-hearing-intro')) {
      setIntroSection(settings);
      prepareFooterData(settings);
    } else if (component.classList.contains('brain-hearing-section-4')) {
      setSliderSection(settings);
    } else {
      setSectionData(settings);
    }
    component.style.display = 'block';
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, introSection && /*#__PURE__*/React.createElement(IntroSectionComponent, {
    settings: introSection
  }), sectionData && /*#__PURE__*/React.createElement(SectionComponent, {
    settings: sectionData,
    footerData: footerData
  }), sliderSection && /*#__PURE__*/React.createElement(SliderSectionComponent, {
    settings: sliderSection,
    footerData: footerData
  }));
};
export default BrainHearingComponent;